import { render, staticRenderFns } from "./MinimumPrice.vue?vue&type=template&id=4f246e2c&scoped=true"
import script from "./MinimumPrice.vue?vue&type=script&lang=js"
export * from "./MinimumPrice.vue?vue&type=script&lang=js"
import style0 from "./MinimumPrice.vue?vue&type=style&index=0&id=4f246e2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f246e2c",
  null
  
)

export default component.exports